import { useLingui } from '@lingui/react/macro'
import { useAdvancedSearchUX } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/AdvancedSearchUXContext'
import { PLACEHOLDER_MAP } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/constants'
import React, { memo } from 'react'

import { SearchToolbar } from './SearchToolbar'

export const LandingSearchBar = memo(function LandingSearchBar() {
  const {
    searchInput,
    handleSearchChange,
    handleSearchKeyDown,
    handleSearchSubmit,
    contentFilter,
    searchSuggestions,
    onSuggestionSelect,
    onClearSearchHistory,
    favoriteSearches,
    isSearchFavorited,
    toggleSearchFavorite,
  } = useAdvancedSearchUX()
  const { i18n } = useLingui()

  return (
    <SearchToolbar
      variant='landing'
      searchInput={searchInput}
      onSearchChange={handleSearchChange}
      onSearchKeyDown={handleSearchKeyDown}
      onSearchSubmit={handleSearchSubmit}
      placeholder={i18n._(PLACEHOLDER_MAP[contentFilter])}
      suggestions={searchSuggestions}
      onSuggestionSelect={onSuggestionSelect}
      onClearHistory={onClearSearchHistory}
      favoriteSearches={favoriteSearches}
      isSearchFavorited={isSearchFavorited}
      onToggleSearchFavorite={toggleSearchFavorite}
      contentFilter={contentFilter}
    />
  )
})
